export default {"src":"/_next/static/media/tik-tok-logo.cd59c85d.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};